import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { api } from "../lib/api";
import { FORM_BY_ID } from "../data/staffFormsSchema";
import FormRenderer from "./FormRenderer";
import { Button } from "../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";

export default function CaseFormDialog({ open, onOpenChange, formType, caseId, existing, onSaved }) {
  const form = FORM_BY_ID[formType];
  const [answers, setAnswers] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setAnswers(existing?.answers || {});
  }, [open, existing]);

  if (!form) return null;

  const save = async () => {
    setSaving(true);
    try {
      if (existing) {
        await api.put(`/case-forms/${existing.form_id}`, { answers });
        toast.success("Form updated.");
      } else {
        await api.post("/case-forms", { case_id: caseId, form_type: formType, answers });
        toast.success("Form saved to the case file.");
      }
      onOpenChange(false);
      onSaved?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not save the form.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-line max-w-3xl max-h-[85vh] overflow-auto" data-testid="case-form-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-navy">{form.id} — {form.title}</DialogTitle>
        </DialogHeader>
        <FormRenderer sections={form.sections} answers={answers} onChange={(k, v) => setAnswers((p) => ({ ...p, [k]: v }))} />
        <div className="mt-8 flex justify-end gap-3 border-t border-line pt-5">
          <Button variant="ghost" onClick={() => onOpenChange(false)} className="text-mutedink" data-testid="case-form-cancel">Cancel</Button>
          <Button onClick={save} disabled={saving} className="bg-teal text-white hover:bg-teal-dark rounded-full" data-testid="case-form-save">
            {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />}
            {existing ? "Update form" : "Save to case file"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
